import axios from 'axios';
import { notifier } from './notifier.js';

export const api = axios.create();

api.interceptors.response.use(
	(response) => {
		if (response.data.result === false) {
			notifier.alert(response.data.message);
		}
		return response.data;
	},
	(error) => {
		console.error('Axios reject on response', error.response);
		return Promise.reject(error);
	}
);

export async function loadTreeData() {
	const response = await api.get('/api/getTree');
	return { data: response.data };
}

export async function loadMyOrders() {
	const response = await api.get('/api/myOrders');
	return { orders: response.data };
}

